import { useEffect, useState } from 'react'

/**
 * Marca `true` assim que o primeiro carregamento termina, e nunca mais volta.
 *
 * Existe para separar "carregando pela primeira vez" de "recarregando". Listas
 * com busca costumam fazer:
 *
 *     if (loading) return <SpinnerDePaginaInteira />
 *
 * e isso quebra o campo de busca: cada tecla dispara o debounce, `loading` volta
 * a `true`, a página inteira é desmontada e o `<input>` remonta como um elemento
 * novo — sem foco e sem cursor. O usuário digita uma letra e o cursor some.
 *
 * Trocar a condição por `loading && items.length === 0` resolve só metade: uma
 * busca sem resultado zera a lista, e a página volta a cair justamente enquanto
 * o usuário digita para refinar. Por isso a marca é "já carregou uma vez", não
 * "tem itens".
 *
 * Uso:
 *
 *     const hasLoadedOnce = useHasLoadedOnce(loading)
 *     if (loading && !hasLoadedOnce) return <SpinnerDePaginaInteira />
 *
 * A partir daí a página permanece montada nos recarregamentos — dê o retorno
 * visual dentro da área de resultados (spinner inline ou lista esmaecida).
 */
export function useHasLoadedOnce(loading: boolean): boolean {
    const [hasLoadedOnce, setHasLoadedOnce] = useState(false)

    useEffect(() => {
        if (!loading) setHasLoadedOnce(true)
    }, [loading])

    return hasLoadedOnce
}
